import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import {
    SubscribersFeaturesSelect,
    featuresSelectCommandTitles,
    isFeaturesDriveNeeded,
    isFeaturesSelectCommand,
} from './SubscribersFeaturesSelect';
import { IChangeStatusCommands } from '../../interfaces';
import { subscribersFeaturesDict } from '../../instruments';
import { tB, tP } from '../../translate';
import { Catcher } from '../Catcher';

type ISubscribersFeaturesSelectModal = {
    children?: never;
    command?: IChangeStatusCommands;
    count: number;
    isLoading?: boolean;
    onCancel: () => void;
    onConfirm: (selectedFeatures: string[]) => void;
};

export const SubscribersFeaturesSelectModal: React.FC<ISubscribersFeaturesSelectModal> = ({
    command,
    count,
    isLoading,
    onCancel,
    onConfirm,
}: ISubscribersFeaturesSelectModal) => {
    const [selectedFeatures, setSelectedFeatures] = useState<string[]>(subscribersFeaturesDict);
    const isSuspend = command === 'block';
    const isOpen = isFeaturesSelectCommand(command);

    useEffect(() => {
        if (isOpen) {
            setSelectedFeatures(subscribersFeaturesDict);
        }
    }, [isOpen]);

    const commandTitle = isOpen && command ? tB(featuresSelectCommandTitles[command]) : '';
    const isDriveNeeded = !!command && isFeaturesDriveNeeded(command, selectedFeatures);

    return (
        <Catcher>
            <Modal
                title={`${commandTitle} — ${tP('Subscribers')} (${count})`}
                wrapClassName={'modal'}
                open={isOpen}
                onOk={(): void => onConfirm(selectedFeatures)}
                onCancel={onCancel}
                okText={isDriveNeeded ? commandTitle : tB('Update')}
                cancelText={tB('Cancel')}
                okButtonProps={{ danger: isSuspend && isDriveNeeded, loading: isLoading }}
                cancelButtonProps={{ disabled: isLoading }}
            >
                <SubscribersFeaturesSelect
                    command={command}
                    isLoading={isLoading}
                    onChange={setSelectedFeatures}
                    value={selectedFeatures}
                />
            </Modal>
        </Catcher>
    );
};
